import { render } from "./AdminBoxEditors.vue?vue&type=template&id=f661f7be&scoped=true"
import script from "./AdminBoxEditors.vue?vue&type=script&lang=js"
export * from "./AdminBoxEditors.vue?vue&type=script&lang=js"

import "./AdminBoxEditors.vue?vue&type=style&index=0&id=f661f7be&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f661f7be"]])

export default __exports__